import jwt_decode from "jwt-decode";

export const AUTH_USER_TOKEN_KEY = 'userToken'

export const AUTH_ADMIN_USER_GROUP = 'admins'

const getDecodedToken = (): { key: string; decoded: any } | null => {
  const key = localStorage.getItem(AUTH_USER_TOKEN_KEY)
  if (key) {
    try {
      const decoded = jwt_decode(key) as any
      if (decoded['exp'] && Date.now() <= (decoded['exp'] * 1000)) {
        return { key, decoded }
      }
    } catch (e) {
      console.error('Invalid token format:', e)
    }
  }
  // Remove expired/invalid token
  localStorage.removeItem(AUTH_USER_TOKEN_KEY)
  return null
}

export const checkAdmin = (): boolean => {
  const result = getDecodedToken()
  if (result) {
    return result.decoded['cognito:groups'] && result.decoded['cognito:groups'].includes(AUTH_ADMIN_USER_GROUP)
  }
  return false
}

export const checkToken = (): boolean => {
  return !!getDecodedToken()
}

/**
 * Get the current auth token for use in authorization headers.
 * Returns the token string if valid, or null if not authenticated.
 */
export const getToken = (): string | null => {
  const result = getDecodedToken()
  return result ? result.key : null
}
